import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { isPersonTravellingWith } from '../../../../../utilities/pages';

function VisaPrepFamilyStep3(props: IVisaPrepForm) {
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.MOTHERS_PERSONAL_DETAILS}
        label={`Do you have your Mother's personal details?`}
        value={boolToYesNo(props.hasMothersPersonalDetails)}
      />
      {props.hasMothersPersonalDetails === true ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            key={VQ.MOTHER_NATIONALITY}
            value={props.motherNationality}
            label={`Mother's Nationality`}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.MOTHER_SAME_NATIONALITY}
            label={'Have they always had the same nationality?'}
            value={boolToYesNo(props.motherSameNationality)}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.MOTHER_FAMILY_NAME}
            value={props.motherFamilyName}
            label={`Mother's Family Name`}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.MOTHER_GIVEN_NAME}
            value={props.motherGivenName}
            label={`Mother's Given Name`}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.MOTHER_DOB}
            label={`Mother's Date of Birth`}
            value={props.motherDob}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.MOTHER_PLACE_OF_BIRTH}
            value={props.motherPlaceOfBirth}
            label={`Mother's Place of birth`}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.MOTHER_TRAVELLING_WITH}
            label={'Is this person travelling with you?'}
            value={props.motherTravellingWith}
          />
          {isPersonTravellingWith(props.motherTravellingWith) ? (
            <>
              <SummaryRow
                className={'visa-summary'}
                key={VQ.MOTHER_UK_VISA}
                label={'Do they have a visa for the UK?'}
                value={props.motherUkVisa}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.MOTHER_HAS_PASSPORT}
                label={'Do they have a Passport or Travel Document?'}
                value={boolToYesNo(props.motherHasPassport)}
              />
              {props.motherHasPassport ? (
                <SummaryRow
                  className={'visa-summary'}
                  key={VQ.MOTHER_PASSPORT_NUMBER}
                  value={props.motherPassportNumber}
                  label={'Current Passport or Travel Document Number:'}
                />
              ) : null}
            </>
          ) : null}
        </>
      ) : null}
    </>
  );
}

export default VisaPrepFamilyStep3;
